import { useWindowDimensions } from "react-native";

export function useWindowDimensions_custom() {
  const { width, height } = useWindowDimensions();
  return { width, height };
}
